const OFFICIAL = {
  MCA: "https://www.mca.gov.in", CBDT: "https://incometaxindia.gov.in", CBIC: "https://cbic-gst.gov.in",
  RBI: "https://www.rbi.org.in", SEBI: "https://www.sebi.gov.in", ICAI: "https://www.icai.org",
  IBBI: "https://ibbi.gov.in", NFRA: "https://nfra.gov.in", "Supreme Court": "https://www.sci.gov.in",
  NCLAT: "https://nclat.nic.in", NCLT: "https://nclt.gov.in",
};

export function kipLink(u) {
  if (u.source_url && u.link_ok === false) {
    const q = encodeURIComponent(`${u.title} ${u.source || ""}`);
    return { href: `https://www.google.com/search?q=${q}`, label: "Removed by publisher · search", dead: true };
  }
  if (u.source_url) return { href: u.source_url, label: "Open source" };
  const home = OFFICIAL[u.source];
  return home ? { href: home, label: `${u.source} official site` } : null;
}
